import { render, staticRenderFns } from "./storeSelect.vue?vue&type=template&id=38c28692&scoped=true&"
import script from "./storeSelect.vue?vue&type=script&lang=js&"
export * from "./storeSelect.vue?vue&type=script&lang=js&"
import style0 from "./storeSelect.vue?vue&type=style&index=0&id=38c28692&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c28692",
  null
  
)

export default component.exports